import { getServerUrl } from './database';
import { getSiteMode } from './siteMode';

export const loginWith = (method: string) => {
  const href = window.location.href;
  const authServerUrl = `${getServerUrl()}/auth/${method}`;
  let originAppUrl = '';

  if (href.includes('localhost')) {
    originAppUrl = 'localhost';
  } else {
    originAppUrl = 'whentaken';
  }

  window.location.href = `${authServerUrl}?referer=${originAppUrl}&siteMode=${getSiteMode()}`;
  return;
};
